import { render, staticRenderFns } from "./base-advantages.vue?vue&type=template&id=04f43718&"
import script from "./base-advantages.vue?vue&type=script&lang=js&"
export * from "./base-advantages.vue?vue&type=script&lang=js&"
import style0 from "./base-advantages.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports